<template>
  <div class="wlx-exam-center-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">认证考核站点申请表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content apply-table-main-con">
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="u-label-title" colspan="2">单位名称</td>
          <td colspan="13" class="u-con-val">
            <p>{{unitName}}</p>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">通讯地址</td>
          <td colspan="6" class="u-con-val">
            <p>{{address}}</p>
          </td>
          <td class="u-label-title" colspan="1">邮编</td>
          <td colspan="6" class="u-con-val">
            <p>{{email}}</p>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2"></td>
          <td class="u-label-title" colspan="1">姓名</td>
          <td class="u-label-title" colspan="3">职务/职称</td>
          <td class="u-label-title" colspan="3">联系电话(常用固定电话)</td>
          <td class="u-label-title" colspan="3">手机号</td>
          <td class="u-label-title" colspan="3">电子邮件/传真</td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">法人代表</td>
          <td colspan="1" class="u-con-val">
            <p>{{legalPerfon.name}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{legalPerfon.job}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{legalPerfon.phone}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{legalPerfon.mobilePhone}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{legalPerfon.email}}</p>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">联系人</td>
          <td colspan="1" class="u-con-val">
            <p>{{linkPerson.name}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{linkPerson.job}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{linkPerson.phone}}</p>
          </td>
           <td colspan="3" class="u-con-val">
            <p>{{linkPerson.mobilePhone}}</p>
          </td>
          <td colspan="3" class="u-con-val">
            <p>{{linkPerson.email}}</p>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">负责区域</td>
          <td colspan="13" class="u-con-val">
            <div class="select-area-con">
              <span class="sp-exam-area-label">考核区域:</span>
              <span>{{provinceValue}}</span>
              <span class="sp-area-label">省</span>
              <span>{{cityValue}}</span>
              <span class="sp-area-label">市</span>
            </div>
          </td>
        </tr>
        <tr v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">
            <td class="u-label-title" colspan="2" rowspan="3">考试场地及设备情况（选择需要的考核方式）</td>
            <td class="u-label-title" colspan="3">实操考核方式</td>
            <td class="u-label-title" colspan="10">
                <!-- <el-input v-model="examAddress"></el-input> -->
                <el-radio-group v-model="isOnline">
                    <el-radio :label="0">线下考核</el-radio>
                    <el-radio :label="1">线上考核</el-radio>
                </el-radio-group>
            </td>
        </tr>
        <tr v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">
            <td class="u-label-title" colspan="3">场地地点</td>
            <td class="u-label-title" colspan="10">
                <el-input v-model="examAddress"></el-input>
            </td>
        </tr>
        <tr v-if="certificateId=='0j6eacat97rafjaiqtfazg'">
            <td class="u-label-title" colspan="2" rowspan="2">考试场地及设备情况</td>
            <td class="u-label-title" colspan="3">场地地点</td>
            <td class="u-label-title" colspan="10">
                <el-input v-model="examAddress"></el-input>
            </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="3">负责人</td>
          <td class="u-label-title" colspan="10">
            <el-input v-model="examPerson"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="1" rowspan="13">人员配配备情况</td>
          <td class="u-label-title" colspan="1">人员</td>
          <td class="u-label-title" colspan="2">姓名</td>
          <td class="u-label-title" colspan="1">性别</td>
          <td class="u-label-title" colspan="2">专/兼职</td>
          <td class="u-label-title" colspan="2">职称</td>
          <td class="u-label-title" colspan="1">专业工龄</td>
          <td class="u-label-title" colspan="5">所属单位名称</td>
        </tr>
        <tr v-for="(item,index) in managerPerson" :key="index">
          <td colspan="1" rowspan="4" v-if="index == 0" class="u-label-title">管理人员</td>
          <td colspan="2" class="u-con-val">
            <p>{{item.name}}</p>
          </td>
          <td colspan="1" class="u-con-val">
            <p>{{item.sex}}</p>
          </td>
          <td colspan="2" class="u-con-val">
            <p>{{item.isFullTime}}</p>
          </td>
          <td colspan="2" class="u-con-val">
            <p>{{item.jobTitle}}</p>
          </td>
          <td colspan="1" class="u-con-val">
            <p>{{item.jobYear}}</p>
          </td>
          <td colspan="5" class="u-con-val">
            <p>{{item.unitName}}</p>
          </td>
        </tr>
        <tr v-for="(item,index) in evaluator" :key="index + 'e'">
          <td colspan="1" rowspan="4" v-if="index == 0" class="u-label-title">考评员</td>
          <td colspan="2" class="u-con-val">
            <p>{{item.name}}</p>
          </td>
          <td colspan="1" class="u-con-val">
            <p>{{item.sex}}</p>
          </td>
          <td colspan="2" class="u-con-val">
            <p>{{item.isFullTime}}</p>
          </td>
          <td colspan="2" class="u-con-val">
            <p>{{item.jobTitle}}</p>
          </td>
          <td colspan="1" class="u-con-val">
            <p>{{item.jobYear}}</p>
          </td>
          <td colspan="5" class="u-con-val">
            <p>{{item.unitName}}</p>
          </td>
        </tr>
        <tr v-for="(item,index) in administrators" :key="index + 'k'">
          <td colspan="1" rowspan="4" v-if="index == 0" class="u-label-title">系统管理员</td>
          <td colspan="2" class="u-con-val">
            <p>{{item.name}}</p>
          </td>
          <td colspan="1" class="u-con-val">
            <p>{{item.sex}}</p>
          </td>
          <td colspan="2" class="u-con-val">
            <p>{{item.isFullTime}}</p>
          </td>
          <td colspan="2" class="u-con-val">
            <p>{{item.jobTitle}}</p>
          </td>
          <td colspan="1" class="u-con-val">
            <p>{{item.jobYear}}</p>
          </td>
          <td colspan="5" class="u-con-val">
            <p>{{item.unitName}}</p>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">申请单位负责人签字单位盖章</td>
          <td class="u-con-val" colspan="13">
            <div class="person-sign-con">
              <p class="p-apply-intro-con">
                  我单位拟向贵处{{certificateName}}的考核站点资质，并按要求提供所需材料(另附)。</p>
              <p class="p-sign-label p-charge-person">负责人签字:</p>
              <p class="p-sign-label">单位公章</p>
            </div>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2">审核意见</td>
          <td class="u-con-val" colspan="13">
            <div class="person-sign-con">
              <p class="approver-person-label">审批人签字盖章:(盖章)</p>
            </div>
          </td>
        </tr>
      </table>
      <div class="p-upload-apply-doc clearfix">
        <p class="sp-upload-file-label" v-if="certificateId=='0j6eacat97rafjaiqtfazg'">供应链运营职业技能等级证书考核站点申请表:</p>
         <p class="sp-upload-file-label" v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">物流管理职业技能等级证书考核站点申请表:</p>
        <applyFileUpload
          :url="urlAliyunOSS"
          :files="files"
          :fileLists="fileList"
          :IsUpload="false"
          :IsPreview="true"
          class="apply-file-upload fl"
        ></applyFileUpload>
      </div>
      <div class="p-upload-apply-doc clearfix">
        <p class="sp-upload-file-label">考试相对固定的场所和相关设备的证明文件:</p>
        <applyFileUpload
          :url="urlAliyunOSS"
          :files="files"
           :fileLists="fileaList"
          :IsUpload="false"
          :IsPreview="true"
          class="apply-file-upload fl"
        ></applyFileUpload>
      </div>
      <div class="p-upload-apply-doc clearfix">
        <p class="sp-upload-file-label">办学机构简介:</p>
        <applyFileUpload
          :url="urlAliyunOSS"
          :files="files"
          :fileLists="filebList"
          :IsUpload="false"
          :IsPreview="true"
          class="apply-file-upload fl"
        ></applyFileUpload>
      </div>
      <div class="p-upload-apply-doc clearfix">
        <p class="sp-upload-file-label">办学机构法人资格证明文件（院校无需提供该证明文件）:</p>
        <applyFileUpload
          :url="urlAliyunOSS"
          :files="files"
          :fileLists="filecList"
          :IsUpload="false"
          :IsPreview="true"
          class="apply-file-upload fl"
        ></applyFileUpload>
      </div>
      <div class="p-upload-apply-doc clearfix">
        <span class="sp-upload-file-label">承诺书（院校需要下载，并在盖章后上传）:
          <a :href="LOUUrl" v-if="certificateId=='dnmeaa2seqbkn9fqiaawfq'">承诺书文件下载</a>
          <a :href="gylCNS" v-if="certificateId=='0j6eacat97rafjaiqtfazg'">承诺书文件下载</a>
          </span>
        <applyFileUpload
          :url="urlAliyunOSS"
          :files="files"
          :fileLists="fileLOUList"
          :IsUpload="false"
          :IsPreview="true"
          class="apply-file-upload fl"
        ></applyFileUpload>
      </div>
      <div class="submit-apply-btn">
        <el-button type="primary" @click="goclpp">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import applyFileUpload from "components/uploads/uploadEnclosure.vue";
export default {
  data() {
    return {
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      unitName: "",
      address: "",
      email: "",
      legalPerfon: {
        name: "",
        job: "",
        phone: "",
        mobilePhone:"",
        email: ""
      },
      linkPerson: {
        name: "",
        job: "",
        phone: "",
        mobilePhone:"",
        email: ""
      },
      managerPerson: [],
      evaluator: [],
      administrators:[],
      examAddress: "",
      isOnline:"",
      examPerson: "",
      provinceOption: [],
      cityOptions: [],
      provinceValue: "",
      cityValue: "",
      isSubmit: false,
      timer: null,
      fileIds: [],
      files: "",
      fileList:[],
      fileaList:[],
      filebList:[],
      fileLOUList:[],
      fileLOUIds: [],
      gylCNS:"https://file.clpp.org.cn/ykt/ori/pzuvaesrpafgwt3kofbgag/TdSSxX4kQPx8hKwN.docx?response-content-disposition=attachment;filename=供应链运营职业技能等级证书考核站点承诺书.docx",
      LOUUrl:"https://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/xcmrPH42MRYpF3d6.docx?response-content-disposition=attachment;filename=考核站点承诺书.docx",
      urlAliyunOSS: "/api/design/osssign/getsign",
      certificateId:"",
      certificateName:""
    };
  },
  components: {
    applyFileUpload
  },
  props: {
    tableId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getProvinceData();
    this.getTableDetail();
  },
  methods: {
    getTableDetail() {
      var that= this;
      this.$http
        .post("/api/XOrg/AssessmentApply/getAssessmentApply", {
          Id: this.tableId
        })
        .then(res => {
          if (res.code > 0) {
            this.unitName = res.info.schoolName;
            this.address = res.info.address;
            this.email = res.info.email;
            this.legalPerfon.name = res.info.legalName;
            this.legalPerfon.job = res.info.legalPost;
            this.legalPerfon.mobilePhone = res.info.legalMobilePhone;
            this.legalPerfon.phone = res.info.legalPhone;
            this.legalPerfon.email = res.info.legalEmail;
            this.linkPerson.name = res.info.contactsName;
            this.linkPerson.job = res.info.contactsPost;
            this.linkPerson.phone = res.info.contactsPhone;
            this.linkPerson.mobilePhone = res.info.contactsMobilePhone;
            this.linkPerson.email = res.info.contactsEmail;
            this.provinceValue = res.info.responsibleProvince;
            this.cityValue = res.info.responsibleCity;
            this.examAddress = res.info.place;
            this.isOnline = res.info.isOnline;
            this.examPerson = res.info.placePerson;
            this.managerPerson = JSON.parse(res.info.personJson);
            this.evaluator = JSON.parse(res.info.examinerJson);
            this.administrators = JSON.parse(res.info.administratorsJson);
            this.fileList = res.fileList;
            this.fileaList = res.fileaList;
            this.filebList = res.filebList;
            this.filecList = res.filecList;
            this.fileLOUList = res.fileLOUList;
            this.certificateId=res.info.certificateId;
            this.certificateName=res.info.certificateName;
            res.fileList.forEach(ele => {
              that.fileIds.push(ele.id);
            });
          }
        });
    },
    getProvinceData() {
      this.$http.post("/api/XOrg/Special/getAllProvinceList").then(res => {
        if (res.code > 0) {
          this.provinceOption = res.province;
        } else {
          this.$message.warning(res.msg);
          return;
        }
      });
    },
    getCityData() {
      this.cityValue = "";
      this.$http
        .post("/api/XOrg/Special/getCityList", {
          province: this.provinceValue
        })
        .then(res => {
          if (res.code > 0) {
            this.cityOptions = res.cityList;
          } else {
            this.$message.warning(res.msg);
            return;
          }
        });
    },
    downloadTable() {
      this.$http.post("/api/XOrg/TrainApply/eportTrainApply", {
        TrainApplyId: this.trainApplyId
      });
    },
    goclpp() {
        // this.$router.push({
        //   name: "assessmentApply"
        // });
         this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
</style>
